import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Suspense as _Suspense, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "poll-page" }
const _hoisted_2 = { class: "poll-content" }
const _hoisted_3 = {
  key: 1,
  class: "poll-layout"
}
const _hoisted_4 = { class: "poll-sidebar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "chapter-number" }
const _hoisted_7 = { class: "chapter-title" }
const _hoisted_8 = { class: "chapter-subtitle" }
const _hoisted_9 = { class: "poll-main" }
const _hoisted_10 = { class: "chapter-header" }
const _hoisted_11 = { class: "question-list" }
const _hoisted_12 = { class: "poll-nav" }


import {
  ref,
  computed,
  defineAsyncComponent,
  onMounted,
} from 'vue';
import { storeToRefs } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';
import AppLoader from '@/components/AppLoader.vue';

const __default__ = { name: 'PollPage' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const ecoStore = useEcoHospitalStore();
const { poll } = storeToRefs(ecoStore);

onMounted(async () => {
  await ecoStore.getPoll();
});

const step = ref(1);
const done = ref(false);
const isMobile = computed(() => window.innerWidth < 900);

const defineFieldType = computed(() => (type: string) => defineAsyncComponent(() => import(`~components/fields/${type}Field.vue`)));

const captureAnswer = (context:any) => {
  const qI = poll.value[step.value - 1].questions
    .findIndex((i) => i.number === context.number);

  if (qI > -1) poll.value[step.value - 1].questions[qI].answers = context.answers;
};

const prevStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value -= 1;
};

const nextStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value += 1;
};

const finishPoll = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  done.value = true;

  useMainStore().showMessage('Спасибо за ответы');
};
// function resetPoll() {
//   done.value = false;
//   step.value = 1;
// }

const goToMain = () => {
  router.push({
    name: 'HealthPageFull',
  });
};


return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_stepper_navigation = _resolveComponent("q-stepper-navigation")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_q_stepper = _resolveComponent("q-stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_q_breadcrumbs, {
        "active-color": "blue-10",
        "separator-color": "blue-10",
        class: "text-blue-grey-10 q-pa-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_breadcrumbs_el, {
            class: "cursor-pointer",
            label: "Главная",
            icon: "home",
            onClick: goToMain
          }),
          _createVNode(_component_q_breadcrumbs_el, {
            label: "Анкетирование",
            icon: "ballot"
          })
        ]),
        _: 1
      }),
      (isMobile.value)
        ? (_openBlock(), _createBlock(_component_q_stepper, {
            key: 0,
            modelValue: step.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step).value = $event)),
            vertical: "",
            animated: "",
            "header-nav": "",
            color: "accent",
            "active-color": "blue-grey-8",
            "done-color": "light-green-6",
            "keep-alive": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return (_openBlock(), _createBlock(_component_q_step, {
                  key: chapter.chapter_number,
                  name: chapter.chapter_number,
                  title: chapter.chapter,
                  caption: chapter.description,
                  icon: "ballot",
                  done: step.value > chapter.chapter_number
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.questions, (question) => {
                          return (_openBlock(), _createBlock(_component_q_item, {
                            key: question.number
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_Suspense, null, {
                                fallback: _withCtx(() => [
                                  _createVNode(AppLoader)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(defineFieldType.value(question.type)), {
                                    context: question,
                                    onHoistAnswer: captureAnswer
                                  }, null, 40, ["context"]))
                                ]),
                                _: 2
                              }, 1024))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_stepper_navigation, null, {
                      default: _withCtx(() => [
                        (chapter.chapter_number > 1)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              flat: "",
                              color: "primary",
                              icon: "arrow_back",
                              label: "Назад",
                              onClick: ($event: any) => (prevStep(chapter))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (chapter.chapter_number < _unref(poll).length)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              color: "accent",
                              icon: "arrow_forward",
                              label: "Далее",
                              onClick: ($event: any) => (nextStep(chapter))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (chapter.chapter_number === _unref(poll).length)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 2,
                              color: "accent",
                              icon: "done",
                              label: "Завершить",
                              onClick: ($event: any) => (finishPoll(chapter))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["name", "title", "caption", "done"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("aside", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: chapter.chapter_number,
                  class: _normalizeClass(["chapter-item", { active: step.value === chapter.chapter_number }]),
                  onClick: ($event: any) => (step.value = chapter.chapter_number)
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(chapter.chapter_number), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(chapter.chapter), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(chapter.description), 1)
                  ])
                ], 10, _hoisted_5))
              }), 128))
            ]),
            _createElementVNode("main", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: chapter.chapter_number
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(chapter.chapter), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.questions, (question) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.number,
                        class: "question-card"
                      }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                          fallback: _withCtx(() => [
                            _createVNode(AppLoader)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(defineFieldType.value(question.type)), {
                              context: question,
                              onHoistAnswer: captureAnswer
                            }, null, 40, ["context"]))
                          ]),
                          _: 2
                        }, 1024))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (chapter.chapter_number > 1)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          icon: "arrow_back",
                          color: "primary",
                          label: "Назад",
                          onClick: ($event: any) => (prevStep(chapter))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (chapter.chapter_number < _unref(poll).length)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          color: "accent",
                          icon: "arrow_forward",
                          label: "Далее",
                          onClick: ($event: any) => (nextStep(chapter))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (chapter.chapter_number === _unref(poll).length)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 2,
                          color: "accent",
                          icon: "done",
                          label: "Завершить",
                          onClick: ($event: any) => (finishPoll(chapter))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_vShow, chapter.chapter_number === step.value]
                ])
              }), 128))
            ])
          ]))
    ])
  ]))
}
}

})